
import authenticate from '@auth/util'
import { CookiesModal } from '@legal/components/CookiesModal'
import Footer from '@navigation/components/Footer'
import AppsflyerMixin from '@tracking/appsflyer/mixin.vue'
import BrazePrompt from '@tracking/braze/components/BrazePrompt.vue'

export default {
  components: {
    Footer,
    BrazePrompt,
    CookiesModal,
  },

  mixins: [AppsflyerMixin],

  computed: {
    shouldRenderCookiesModalClientSide() {
      return this.$config.FF_COOKIES_MODAL_RENDERED_CLIENT_SIDE_IN_COUNTRY?.includes(
        this.country,
      )
    },
  },

  beforeMount() {
    authenticate({
      store: this.$store,
      config: this.$config,
    })
  },
}
